import ShiftReport from "./ShiftReport.component.jsx";

export default ShiftReport;
